import React, { ChangeEvent } from 'react';
import { Icon } from 'components';
import { TextField } from 'e100-react-components';
import { useStyles } from './styles';
import { useIsDisabledFilterButton, useMyFleetOperations } from 'features/myFleet/hooks';
import { useIntl } from 'react-intl';

interface SearchCarMyFleetProps {
  endAdornment?: JSX.Element;
}

export const SearchCarMyFleet = ({ endAdornment }: SearchCarMyFleetProps) => {
  const classes = useStyles();
  const { setSearchValue } = useMyFleetOperations();
  const isDisabledFilterButton = useIsDisabledFilterButton();
  const { formatMessage } = useIntl();

  const onSearch = (value: string) => {
    setSearchValue(value);
  };

  return (
    <TextField
      disabled={isDisabledFilterButton}
      classes={{ root: classes.root }}
      InputProps={{
        classes: { root: classes.input },
        placeholder: formatMessage({ id: 'searchVehicle' }),
        startAdornment: <Icon kind="search" />,
        endAdornment,
        onInput: (e: ChangeEvent<HTMLInputElement>) => onSearch(e.target.value),
      }}
    />
  );
};
